import { defaultClient as ApolloClient } from "../../../main";
import {
  GET_DRILL_LIB,
  FAVORITE_DRILL_LIB_GET
} from "../../../graphql/drills/drillsQ";
import {
  DRILL_MERGE,
  DRILL_DEL,
  FAVORITE_DRILL_LIB_MERGE
} from "../../../graphql/drills/drillsM";
import { randomInteger } from "../../../_helpers/index";

export const actions = {
  allDrillLib: async ({ commit }, payload) => {
    commit("setLoading", true);
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_DRILL_LIB,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setDrillLib", data.allDrillLib);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  /****************DRILLS MERGE**********************************/
  drillMerge: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DRILL_MERGE,
      variables: payload,
      update: (cache, { data: { drillMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_DRILL_LIB
          });
          drillMerge.node.user = payload.user;
          drillMerge.node.favoriteDrillLib = {
            edges: [],
            __typename: "FavoriteDrillLib"
          };
          data.allDrillLib.edges.push(drillMerge);
          cache.writeQuery({
            query: GET_DRILL_LIB,
            data
          });
        } catch (error) {
          console.error(`Error in drillMerge update hook. Full info: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allDrillLib");
      })
      .catch(err => {
        console.error(`Error in drillMerge action. Full info: ${err}`);
      });
  },

  drillEdit: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DRILL_MERGE,
      variables: payload,
      update: (cache, { data: { drillMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_DRILL_LIB
          });
          console.log(data);
          const allDrill = data.allDrillLib.edges.filter(
            el => +el.node.drillId === +payload.drillId
          );
          const drillIndx = data.allDrillLib.edges.indexOf(allDrill[0]);
          if (drillIndx !== -1) {
            drillMerge.node.user = payload.user;
            if (payload.favoriteDrillLib) {
              drillMerge.node.favoriteDrillLib = payload.favoriteDrillLib;
            } else {
              drillMerge.node.favoriteDrillLib = {
                edges: [],
                __typename: "FavoriteDrillLib"
              };
            }
            data.allDrillLib.edges[drillIndx] = drillMerge;
          } else {
            console.error(
              "Error in drillEdit hook. No index for current drillMerge"
            );
          }
          cache.writeQuery({
            query: GET_DRILL_LIB,
            data
          });
        } catch (error) {
          console.error(`Error in drillEdit update hook. Full info: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allDrillLib");
      })
      .catch(err => {
        console.error(`Error in drillEdit action. Full info: ${err}`);
      });
  },

  /****************DRILLS DELETE**********************************/
  drillDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DRILL_DEL,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_DRILL_LIB
          });
          data.allDrillLib.edges = data.allDrillLib.edges.filter(
            item => +item.node.drillId !== +payload.drillId
          );
          cache.writeQuery({
            query: GET_DRILL_LIB,
            data
          });
        } catch (error) {
          console.error(
            `Error in drillDelete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allDrillLib");
      })
      .catch(err => {
        console.error(`Error in drillDelete action. Full info: ${err}`);
      });
  },
  allFavoriteDrillLib: async ({ commit }, payload) => {
    commit("setLoading", true);
    return ApolloClient.query({
      query: FAVORITE_DRILL_LIB_GET,
      variables: payload
    })
      .then(({ data }) => {
        commit("setFavoriteDrillLib", data.allFavoriteDrillLib);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  favoriteDrillLibMerge: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: FAVORITE_DRILL_LIB_MERGE,
      variables: payload,
      update: (cache, { data: { favoriteDrillMerge } }) => {
        try {
          const data = cache.readQuery({
            query: FAVORITE_DRILL_LIB_GET,
            variables: {
              userId: payload.userId
            }
          });
          console.log(favoriteDrillMerge);
          if (payload.favdrillId === 0) {
            favoriteDrillMerge.node.favdrillId = String(randomInteger(1, 1200));
            favoriteDrillMerge.node.user = payload.user;
            data.allFavoriteDrillLib.edges.push(favoriteDrillMerge);
          } else {
            data.allFavoriteDrillLib.edges = data.allFavoriteDrillLib.edges.filter(
              drill => +drill.node.favdrillId !== +payload.favdrillId
            );
          }
          console.log(data);
          cache.writeQuery({
            query: FAVORITE_DRILL_LIB_GET,
            variables: {
              userId: payload.userId
            },
            data
          });
        } catch (error) {
          console.error(
            `Error in favoriteDrillLibMerge update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allFavoriteDrillLib");
        // if (!payload.favdrillId) {
        //   const favoriteDrillLib = {
        //     edges: [...state.favoriteDrillLib.edges, data.favoriteDrillMerge]
        //   };
        //   commit("setFavoriteDrillLib", favoriteDrillLib);
        // } else {
        //   const index = state.favoriteDrillLib.edges.findIndex(
        //     favDrill => favDrill.node.favdrillId == payload.favdrillId
        //   );

        //   if (index != -1) {
        //     // Delete record from array 111
        //     const favoriteDrillLib = {
        //       edges: [
        //         ...state.favoriteDrillLib.edges.slice(0, index),
        //         ...state.favoriteDrillLib.edges.slice(index + 1)
        //       ]
        //     };
        //     // update     const favoriteDrillLib =  {edges:[...state.favoriteDrillLib.edges.slice(0, index), data.favoriteDrillMerge, ...state.favoriteDrillLib.edges.slice(index +1)]};
        //     commit("setFavoriteDrillLib", favoriteDrillLib);
        //   }
        // }
      })
      .catch(err => {
        console.error(
          `Error in favoriteDrillLibMerge action. Full info: ${err}`
        );
      });
  }
};
